module.exports = __webpack_public_path__ + "img/icon_sm_ccprk.f7190716.png";